(function ($) {

  $(window).on('scroll',function(){
    var st = $(window).scrollTop();
    
    var cp = $('#collection-products');
    if($(cp).length>0)
    {
      var heightMax = $('#collection-products').offset().top + $('#collection-products').height() - $(window).height();
      if(heightMax-st<100)
      {
        $('#load-more-wrapper a').trigger('click');
      }
    }
  })

  

  
  // $("#the-payment-buttons").after($("#icons"));
    $(document).ready(function () {

    $('#wir-wollen .the-button').click(function(e){
      e.preventDefault();

      if ($(this).attr('href') == '') {
        
        $(this).parent().remove();
        $('#wir-wollen-reviews').css('display','block');
        window.dispatchEvent(new Event('resize'));
        setTimeout(function(){
          window.dispatchEvent(new Event('resize'));
        },500);
      } else {
        console.log('he1');
        location.href = $(this).attr('href');
      }
    });

    $('.play-video').click(function(e){
      e.preventDefault();
      var href = $(this).attr('href');
      var wrapper = $('<div class="video-wrapper"></div>');
      var is_youtube = href.indexOf('youtube')!==-1;
      
      if(is_youtube)
      {
        var video = $('<iframe width="560" height="315" src="https://www.youtube.com/embed/LXb3EKWsInQ?si=0cCAHaZmMHJYzYAp&autoplay=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
      }
      else
      {
        var video = $('<video autoplay controls><source src="'+href+'" type="video/mp4"></source></video>');
      }

      $(wrapper).append(video);
      $(this).after(wrapper);
      $(this).remove();
      
    });

   setTimeout(function(){
      if($('.top-right-product .jdgm-prev-badge__stars').length>0)
    {
      var clonerew = $('.top-right-product .jdgm-prev-badge').clone();  
      $('.sticky-cart__content-heading').append(clonerew);
    }
   },3000);
    
    

    if($('.pagination__list').length>0)
    {
      var loadMoreButton = $('<p class="text-center" id="load-more-wrapper"><a href="#" class="the-button empty-button">Load more</a></p>');
      $('.pagination__list').after(loadMoreButton);
      var page = 1;
      var blocked = false;
      var maxPages = $('.pagination__list li').length-1;
      
      $(loadMoreButton).find('a').click(function(e){
        if(!blocked)
        {
          var button = $(this);
        $(button).css('opacity','0.5');
        blocked = true;
        
        e.preventDefault();
        page++;
        var url = $('.pagination__list li:nth-child('+page+') a').attr('href');
        
          $.ajax({
            url:url,
            success:function(data){
              
              $(button).css('opacity','');
               blocked = false;
              var products = $(data).find('#collection-products .col-lg-3');
              $('#collection-products .row').append(products);
              
              if(page===maxPages)
              {
                $('#load-more-wrapper').remove();
              }
            }
          })
          
        }
        
      });
}

    $('.add-to-cart-new-icon').click(function(e){
      e.preventDefault();
      var url = $(this).attr('url');
      $(this).css('opacity','0.5');

      const upsellProductsInput = $(this).find('.upsell-products-input');
      const upsellProducts = upsellProductsInput.length ? upsellProductsInput.val() : null;
      const autoAddUpsell = $(this).find('input[name="auto_add_upsell"]').val() === "true";

      let items = [{
        id: $(this).attr('data-id'),
        quantity: 1
      }];

      if (upsellProducts && autoAddUpsell) {
        const upsellIds = upsellProducts.split(',');
        upsellIds.forEach(id => {
          items.push({
            id: parseInt(id),
            quantity: 1
          });
        });
      }
    
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items },
        dataType: 'json',
        success: function() { 
          window.setCookie('show_cart','true',1);
          window.location.reload(true);
        }
      });

   /* jQuery.post('/cart/add.js', {
      'form_type':'product',
      'id':$(this).attr('data-id'),
      'quantity':1
    },function(data)
  {
    window.setCookie('show_cart','true',1);
    window.location.reload(true);
  },'json');*/

      
    });


 $('.sticky-cart__content-heading h3').html($('h1').text());
    

    $('.about-hero .the-button').removeClass('empty-button');

    $('.change-name a').click(function(e)
                            {
                              var textVal = $(this).text().trim();
                              $('#sort-wrapper .filter-title span').html(textVal)
                            });

    $('.mobile-trigger-wrapper').click(function(e){
      e.preventDefault();
      if($(window).width()<=1024)
      {
        $('#mobile-sort-wrapper').toggleClass('active');
      $('body').addClass('no-scroll');  
      }
      
    });

    $('.dropdown-expanded a').click(function(e){
      $('body').removeClass('no-scroll');
    });
    

    $('.dropdown-expanded .overlay-filter').click(function(e)
                                                  {
                                                    $('#mobile-sort-wrapper').removeClass('active');
                                                    e.preventDefault();
$(this).closest('.dropdown-expanded').slideUp(550);
  $('#sort-wrapper,.sort-wrapper').removeClass('active');

                                                    
                                                    $('body').removeClass('no-scroll');
                                                  });

    
    $('.section-testimonials .row,#product-page-recipes .row').slick({
      responsive:[
        {
        breakpoint:100000,
        settings:'unslick'
        },
      {
      breakpoint: 575,
      settings:{
           adaptiveHeight:true,
          arrows:true,
          dots:true,
          slidesToShow:1,
          
         
        }
      }
      
      ]
    })

    if($(window).width()<575)
    {
      
    }
    


    
    ////////////////////////////////////////////////////
    // 1) Prepare global variables and utility functions
    ////////////////////////////////////////////////////
    
    let foundSet = false;              // Tracks whether any item is a 'set'
    let productGroups = {};            // Stores final 'set' or 'single' status per product ID
    let productDataMap = {};           // Temporary storage for product data used for rendering
    let maxDiscounts = { single: 0, set: 0 };  // Tracks max discount for each tab
    let promises = [];                 // Collect all Promises
    
    // Converts a raw ID (could be numeric or GID) into a consistent numeric string
    function normalizeProductId(rawId) {
      if (rawId.startsWith('gid://shopify/Product/')) {
        // Example: "gid://shopify/Product/14883558818172" -> "14883558818172"
        return rawId.split('/').pop();
      }
      return rawId;
    }
    
    // Decide if a product is 'set' or 'single' without overwriting 'set' with 'single'
    function setProductGroup(rawId, isSet) {
      const productId = normalizeProductId(rawId);
      // console.log('setProductGroup call:', { productId, isSet });
      // console.log('before:', productGroups[productId]);
      // If it's already 'set', do nothing (don't revert 'set' to 'single')
      if (productGroups[productId] === 'set') {
        return;
      }
      
      // If undefined, set it based on isSet
      if (productGroups[productId] === undefined) {
        productGroups[productId] = isSet ? 'set' : 'single';
        // console.log('lets ch1');
      } else {
        // If it was 'single' but now isSet = true, upgrade to 'set'
        if (productGroups[productId] === 'single' && isSet) {
          // console.log(productId, 'lets ch2');
          productGroups[productId] = 'set';
        }
      }
      // console.log('after:', productGroups[productId]);
    }
    
    //////////////////////////////////////
    // 2) Create the tabs container in DOM
    //////////////////////////////////////
    if (typeof variations_new !== "undefined") {
      // Insert the HTML for tabs
      const variationsWrapper = $(`
        <div id="var-wrapper">
          <h3>Wähle eine Produktvariante</h3>
          <div id="tabs-container" style="display: none;">
            <button class="tab" id="tab-einzeln-button">Einzeln</button>
            <button class="tab" id="tab-im-set-button">Im Set</button>
          </div>
          <div id="tab-einzeln" class="tab-content"><div id="var-inside"></div></div>
          <div id="tab-im-set" class="tab-content"><div id="var-inside"></div></div>
        </div>
      `);
    
      $(".incl").after(variationsWrapper);
    
      // Parse debug data to fill the `ids` array (id -> [handle, debugTitle])
      let debug = $('#debug').text().trim();
      let ids = [];
      let rows = debug.split('::::');
      $(rows).each(function (kkk, vvv) {
        let cols = vvv.split(':::');
        if (cols.length >= 3) {
          let id = parseInt(cols[0].trim());
          let url = cols[1].trim().replace('/products/', '');
          let title = cols[2].trim();
          ids[id] = [url, title];
        }
      });
    
      ///////////////////////////////////////
      // 3) Collect data per product (async)
      ///////////////////////////////////////
      $(variations_new).each(function (k, v) {
        // Extract the raw ID
        let rawId = v.split("/").pop();
        
        // Check if `ids[rawId]` is known
        if (typeof ids[rawId] !== 'undefined') {
          let handle = ids[rawId][0];
          let debugTitle = ids[rawId][1];
          let productId = normalizeProductId(rawId);
          console.log(productId, handle);
          // Prepare an object to store product info
          productDataMap[productId] = {
            handle: handle,
            // Will override with HTML-based title after fetching
            title: debugTitle,
            price: null,
            compareAtPrice: null,
            order: k
          };
    
          let storefrontAccessToken = 'd87fca87922c804866aa3fa35913f35c';
          let shopDomain = 'silberthal.myshopify.com';
    
          // GraphQL queries for the parent
          let queryProduktvariantenbuybox = `
            {
              productByHandle(handle: "${handle}") {
                metafield(namespace: "custom", key: "produktvariantenbuybox") {
                  value
                }
              }
            }
          `;
          let querySet = `
            {
              productByHandle(handle: "${handle}") {
                metafield(namespace: "custom", key: "set_") {
                  value
                }
              }
            }
          `;
    
          // We'll fetch product JSON for variant data, plus the product page HTML
          let productJsonUrl = "/products/" + handle + ".js";
          let productHtmlUrl = "/products/" + handle;
    
          // Create four Promises for the parent
          let p1 = fetch(`https://${shopDomain}/api/2023-01/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken
            },
            body: JSON.stringify({ query: queryProduktvariantenbuybox })
          }).then(r => r.json());
    
          let p2 = fetch(`https://${shopDomain}/api/2023-01/graphql.json`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': storefrontAccessToken
            },
            body: JSON.stringify({ query: querySet })
          }).then(r => r.json());
    
          let p3 = $.ajax({
            url: productJsonUrl,
            dataType: "json"
          });
    
          let p4 = $.ajax({
            url: productHtmlUrl,
            type: "get",
            dataType: "html"
          });
    
          // Combine these Promises for the PARENT
          let promise = Promise.all([p1, p2, p3, p4])
            .then(function (results) {
              let produktvariantenbuyboxResult = results[0];
              let setResult = results[1];
              let productJsData = results[2];
              let dataTitle = results[3];  // HTML text of the product page
    
              // (1) Check "set_" metafield for the parent
              let setField = (
                setResult.data &&
                setResult.data.productByHandle &&
                setResult.data.productByHandle.metafield
              )
                ? setResult.data.productByHandle.metafield.value
                : null;
    
              console.log(results);
              
              let isSet = (setField === 'true');
              if (isSet) {
                foundSet = true;
              }
    
              // (2) Check "produktvariantenbuybox"
              let buyboxValue = (
                produktvariantenbuyboxResult.data &&
                produktvariantenbuyboxResult.data.productByHandle &&
                produktvariantenbuyboxResult.data.productByHandle.metafield
              )
                ? produktvariantenbuyboxResult.data.productByHandle.metafield.value
                : null;
    
              // If there's a child array
              if (buyboxValue) {
                try {
                  buyboxValue = JSON.parse(buyboxValue);
                } catch (e) {
                  console.error('Error parsing produktvariantenbuybox:', e);
                  buyboxValue = [];
                }
    
                if (Array.isArray(buyboxValue)) {
                  // For each child ID, we do an additional fetch
                  buyboxValue.forEach(childId => {
                    let childIdNormalized = normalizeProductId(childId);
    
                    // Make sure we have a handle for the child
                    
                      let childHandle = ids[childIdNormalized][0];
                      // We will do a separate GraphQL request for the child's set_ metafield
                      let childQuerySet = `
                        {
                          productByHandle(handle: "${childHandle}") {
                            metafield(namespace: "custom", key: "set_") {
                              value
                            }
                          }
                        }
                      `;
    
                      // You could also fetch child product JSON if needed for price, etc.
    
                      let childPromise = fetch(`https://${shopDomain}/api/2023-01/graphql.json`, {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json',
                          'X-Shopify-Storefront-Access-Token': storefrontAccessToken
                        },
                        body: JSON.stringify({ query: childQuerySet })
                      })
                      .then(resp => resp.json())
                      .then(childResult => {
                        let childSetValue = (
                          childResult.data &&
                          childResult.data.productByHandle &&
                          childResult.data.productByHandle.metafield
                        )
                          ? childResult.data.productByHandle.metafield.value
                          : null;
    
                        // If the child's own set_ is "true"
                        
                        // if (childResult.data.productByHandle == null) {
                        //   let isChildSet = "true";
                        // } else {
                          let isChildSet = (childSetValue === "true");
                        // }
    
                        setProductGroup(childId, isChildSet);
                        
                      })
                      .catch(err => {
                        console.error("Error fetching child product's set_:", childId, err);
                      });
    
                      // Add this child's promise to the global promises array
                      promises.push(childPromise);
                    
                  });
                }
              }
              // console.log(rawId, setResult.data, produktvariantenbuyboxResult)
              // Mark the parent itself as set or single
              if (setResult.data.productByHandle == null) {
                setProductGroup(rawId, "true");
              } else {
                setProductGroup(rawId, isSet);
              }
              
    
              // (3) Process JSON data for price, compare_at_price
              if (productJsData && productJsData.variants && productJsData.variants.length > 0) {
                let variant = productJsData.variants[0];
                productDataMap[productId].price = variant.price; // in cents
                productDataMap[productId].compareAtPrice = variant.compare_at_price;
                productDataMap[productId].available = variant.available;
                
              }
    
              // (4) Parse HTML for title or variant name
              let tempDom = $('<div>').append($.parseHTML(dataTitle));
              let foundTitle = tempDom.find("h1").text().trim();
              let foundVariantName = tempDom.find(".variant-name").text().trim();
              if (foundVariantName !== "") {
                foundTitle = foundVariantName;
              }
              if (foundTitle) {
                productDataMap[productId].title = foundTitle;
              }
            })
            .catch(function (error) {
              console.error('Error in Promise.all for product:', rawId, error);
            });
    
          // Add the parent's promise to the main array
          promises.push(promise);
        }
      });
    
      //////////////////////////////////////////////////
      // 4) After all Promises are done, render the tabs
      //////////////////////////////////////////////////
      Promise.all(promises).then(() => {
        // Formats price from cents
        function formatPrice(cents) {
          if (!cents) return "";
          let priceNum = cents / 100;
          return new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR'
          }).format(priceNum);
        }
    
        // Iterate over each product we processed
        for (let productId in productDataMap) {
          if (!productDataMap.hasOwnProperty(productId)) continue;
    
          let dataObj = productDataMap[productId];
          let group = productGroups[productId]; // 'set' or 'single'
          let handle = dataObj.handle;
          let title_new = dataObj.title;
          let order = dataObj.order;
          let price = dataObj.price;
          let compareAtPrice = dataObj.compareAtPrice;
    
          // Build the <a> element using the final extracted title
          let $a = $('<a href="/products/' + handle + '">' + title_new + "</a>");
          $a.css('order', order);

          if (!dataObj.available) {
            $a.addClass('out-of-stock');
          }
    
          // If there's a global `current_handle` and it matches, mark as active
          if (typeof current_handle !== "undefined" && handle === current_handle) {
            $a.addClass("active");
          }
    
          // Display prices
          let priceFormatted = formatPrice(price);
          let compareFormatted = formatPrice(compareAtPrice);
    
          let priceHtml = '<div class="price">' + priceFormatted + '</div>';
          if (compareAtPrice && compareAtPrice > price) {
            let discountPercentage = Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
            if (discountPercentage > maxDiscounts[group]) {
              maxDiscounts[group] = discountPercentage;
            }
            priceHtml = `
              <div class="price">
                <div class="compare-at-price">${compareFormatted}</div>
                ${priceHtml}
              </div>
            `;
            $a.addClass('has-discount');
            $a.append(`<span class="discount-percentage">-${discountPercentage}% Sparen</span>`);
          }
    
          // Optionally prepend a container for the parsed title
          $a.prepend(`<div class="changed-title"></div> ${priceHtml}`);
    
          // Append to the correct tab
          if (group === 'single') {
            $("#tab-einzeln #var-inside").append($a);
          } else if (group === 'set') {
            $("#tab-im-set #var-inside").append($a);
          } else {
            // Fallback if group is missing
            $("#var-inside").append($a);
          }
        }
    
        // Update the tab discount badges
        for (let g in maxDiscounts) {
          if (!maxDiscounts.hasOwnProperty(g)) continue;
          let maxD = maxDiscounts[g];
          if (maxD > 0) {
            let tabButtonId = (g === 'single') ? '#tab-einzeln-button' : '#tab-im-set-button';
            $(tabButtonId).find('.discount-percentage').remove();
            $(tabButtonId).append(`<span class="discount-percentage">-${maxD}% Sparen</span>`);
          }
        }
    
        // Call existing tab-check and default-tab logic
        checkAndUpdateTabs();
        initializeDefaultTab();
      });
    }
    
    //////////////////////////////////////////////////////////////
    // 5) Additional code (bulk discounts, tabs, etc.) goes below
    //////////////////////////////////////////////////////////////
    
    if (typeof productbulkdiscounts !== "undefined") {
      $(".info-options a").remove();
      $(productbulkdiscounts.children).each(function (k, v) {
        let val = v.children[0].value.split(";");
        $(".info-options").append(
          '<a href="#"><span>' +
            val[0] +
            "</span><span>" +
            val[1] +
            "</span></a>"
        );
      });
    }
    
    // Example tab logic (as in the original code):
    function checkAndUpdateTabs() {
      if ($("#tab-im-set #var-inside").children().length === 0) {
        $("#tabs-container").hide();
      } else {
        $("#tabs-container").show();
      }
    
      if ($("#tab-im-set #var-inside").children().length === 0) {
        $("#tab-im-set").addClass('notactive');
        $("#tab-im-set-button").hide();
      } else {
        $("#tab-im-set").removeClass('notactive');
        $("#tab-im-set-button").show();
        if ($("#tab-im-set #var-inside .active").length > 0) {
          $("#tab-im-set").addClass('active');
        }
      }
    
      if ($("#tab-einzeln #var-inside").children().length === 0) {
        $("#tab-einzeln").addClass('notactive');
        $("#tab-einzeln-button").hide();
      } else {
        $("#tab-einzeln").removeClass('notactive');
        $("#tab-einzeln-button").show();
        if ($("#tab-einzeln #var-inside .active").length > 0) {
          $("#tab-einzeln").addClass('active');
        }
      }
    }
    
    function initializeDefaultTab() {
      if ($("#tab-einzeln #var-inside .active").length > 0) {
        $("#tab-einzeln-button").click();
      } else if ($("#tab-im-set #var-inside .active").length > 0) {
        $("#tab-im-set-button").click();
      } else if ($("#tab-einzeln-button").is(':visible')) {
        $("#tab-einzeln-button").click();
      } else if ($("#tab-im-set-button").is(':visible')) {
        $("#tab-im-set-button").click();
      }
    }
    
    // Handling tab clicks
    $(document).on('click', '.tab', function () {
      var tabId = $(this).attr('id');
      $('.tab-content').hide();
      $('.tab').removeClass('active');
      $(this).addClass('active');
    
      if (tabId === 'tab-einzeln-button') {
        $('#tab-einzeln').show();
      } else if (tabId === 'tab-im-set-button') {
        $('#tab-im-set').show();
      }
    });

    $(document).on('click', '.info-options .close', function (e) {
        e.preventDefault();
        $(this).closest('.info-options').removeClass('active');
    });
    
    $(document).on('click', '.menge-text > span', function (e) {
        e.stopPropagation();
        $(this).closest('.menge-text').find('.info-options').toggleClass('active');
    });
    
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.info-options, .menge-text > span').length) {
            $('.info-options').removeClass('active');
        }
    });
    

    $(".more-button").click(function (e) {
      e.preventDefault();
      $(".hidden-on-mobile").removeClass("hidden-on-mobile");
      $(this).parent().remove();
    });

    $(".mid-footer-header.menu-header").click(function (e) {
      e.preventDefault();
      $(this).next().slideToggle(550);
      $(this).toggleClass("active");
    });

    $(".mid-footer-header.menu-header").append(
      $(
        '<svg xmlns="http://www.w3.org/2000/svg" width="10.504" height="6.126" viewBox="0 0 10.504 6.126">  <path id="Vector" d="M5.87,4.634a.876.876,0,0,1,0,1.239L1.5,10.248A.876.876,0,1,1,.256,9.009L4.013,5.252.259,1.5A.876.876,0,0,1,1.5.256L5.873,4.631Z" transform="translate(10.504) rotate(90)" fill="#1d3238"/></svg>'
      )
    );

    $(".one-accordion-question").click(function (e) {
      e.preventDefault();
      var wrapper = $(this).closest(".aw-wrapper");
      var active = false;
      if ($(this).parent().hasClass("active")) {
        var active = true;
      }

      $(wrapper).find(".one-accordion").removeClass("active");
      $(wrapper).find(".one-accordion-answer").slideUp(550);

      if (!active) {
        $(this).closest(".one-accordion").addClass("active");
        $(this)
          .closest(".one-accordion")
          .find(".one-accordion-answer")
          .slideDown(550);
      }
    });

    setTimeout(function () {
      // $(".jdgm-prev-badge__text").each(function (k, v) {
      //   var sterne = $(this)
      //     .closest(".one-product-slide")
      //     .find(".sterne")
      //     .html();
      //   $(this).closest(".one-product-slide").find(".sterne").remove();
      //   if (sterne !== "" && typeof sterne !== "undefined") {
      //     $(this).html(
      //       sterne +
      //         ' <span class="sterne-text"><span class="the-sterne-text">Sterne</span> ' +
      //         $(this).html().replace('reviews','') +
      //         "</span>"
      //     );
      //   }
      // });
      // $("#the-payment-buttons").after($("#icons"));

      // $(".product-details .jdgm-prev-badge__text").each(function () {
      //   var sterne = $(this).prev().attr("data-score");
        
      //   if (typeof sterne !== "undefined" && sterne !== "") {
      //     $(this).html(
      //       sterne +
      //         ' <span class="sterne-text">Sterne ' +
      //         $(this).html().replace('reviews','') +
      //         "</span>"
      //     );
      //   }
      // });
    }, 2000);

    // $("#the-payment-buttons").after($("#icons"));

    if ($(".one-product-question").length > 0 && $(window).width() > 576) {
      $(".one-product-faq")
        .find(".one-product-question")
        .first()
        .trigger("click");
    }


$('.products-slider-top a:last-child').trigger('click');
  setTimeout(function(){
    $('.products-slider-top a:last-child').trigger('click');
  },500);

    
  });

  $('.upsell-products1__close').click(function(){
    $('.upsell-products1').fadeOut('fast');
  });


$(document).ready(function(){
  var videoSlideIndex = null; // Initialize as null
  var slidesToShow = 6; // Default number of thumbnails to show
  var hasVideo = $('.video-thumbnail-wrapper').length != 0; // Check if video exists

  if (hasVideo) {
    videoSlideIndex = 5; // Index of the video slide
    slidesToShow = 5; // Show 5 image thumbnails if video exists
  }

  // Initialize the main slider
  $('.main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    asNavFor: '.thumbnails-slider', // Link to the thumbnails slider
  });

  $(document).ready(function () {
      const videos = $('.slick-slider video');
  
      videos.each(function () {
          this.load();
      });
  });

  // Initialize the thumbnails slider
  $('.thumbnails-slider').slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    asNavFor: '.main',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
    // Add centerMode and variableWidth if needed
    // centerMode: true,
    // variableWidth: true,
  });

  // Create an index map to align thumbnail indexes with main slider indexes
  var indexMap = [];
  var thumbnailCount = $('.thumbnails-slider .thumbnail').length;
  for (var i = 0; i < thumbnailCount; i++) {
    if (hasVideo && i >= videoSlideIndex) {
      indexMap[i] = i + 1; // Adjust indexes after video slide
    } else {
      indexMap[i] = i;
    }
  }

  // Set data-slide-index attribute for thumbnails
  $('.thumbnails-slider .thumbnail').each(function(i){
    $(this).attr('data-slide-index', indexMap[i]);
  });

  // Handle click on image thumbnails
  $('.thumbnails-slider .thumbnail').on('click', function(e) {
    e.preventDefault();
    var index = $(this).data('slide-index');
    $('.main').slick('slickGoTo', index);
    setActiveThumbnail(index);
  });

  // Handle click on video thumbnail (only if video exists)
  if (hasVideo) {
    $('.video-thumbnail-wrapper .thumbnail').on('click', function(e) {
      e.preventDefault();
      $('.main').slick('slickGoTo', videoSlideIndex);
      setActiveThumbnail(videoSlideIndex);
    });
  }

  // Update active thumbnail when main slider changes
  $('.main').on('afterChange', function(event, slick, currentSlide){
    setActiveThumbnail(currentSlide);
    // Adjust thumbnails slider to keep active thumbnail in view
    var thumbnailIndex = currentSlide;
    if (hasVideo && currentSlide > videoSlideIndex) {
      thumbnailIndex = currentSlide - 1;
    }
    $('.thumbnails-slider').slick('slickGoTo', thumbnailIndex);
  });

  // Function to set active thumbnail
  function setActiveThumbnail(index) {
    $('.thumbnails-slider .thumbnail, .video-thumbnail-wrapper .thumbnail').removeClass('active');

    if (hasVideo && index == videoSlideIndex) {
      $('.video-thumbnail-wrapper .thumbnail').addClass('active');
    } else {
      var thumbnailIndex = index;
      if (hasVideo && index > videoSlideIndex) {
        thumbnailIndex = index - 1; // Adjust index for thumbnails after video
      }
      $('.thumbnails-slider .thumbnail').eq(thumbnailIndex).addClass('active');
    }
  }

  // Set initial active thumbnail
  var initialSlide = $('.main').slick('slickCurrentSlide');
  setActiveThumbnail(initialSlide);
});


  
})(jQuery);

window.addEventListener('load', function() {
  function addClassToTrustbadge() {
    var trustbadgeElement = document.querySelector('[id^="trustbadge-container"]');
    if (trustbadgeElement) {
      trustbadgeElement.classList.add('trustb');
      clearInterval(checkExist);
    }
  }

  var checkExist = setInterval(addClassToTrustbadge, 500);
  addClassToTrustbadge();
});

// Product page initialization
$(document).ready(function(){
  var videoSlideIndex = null;
  var slidesToShow = 6;
  var hasVideo = $('.video-thumbnail-wrapper').length != 0;

  if (hasVideo) {
    videoSlideIndex = 5;
    slidesToShow = 5;
  }

  // Initialize the main slider
  $('.main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: false,
    asNavFor: '.thumbnails-slider',
  });

  // Initialize the thumbnails slider
  $('.thumbnails-slider').slick({
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    asNavFor: '.main',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    infinite: false,
  });

  // Create an index map to align thumbnail indexes with main slider indexes
  var indexMap = [];
  var thumbnailCount = $('.thumbnails-slider .thumbnail').length;
});


document.addEventListener("DOMContentLoaded", () => {
  // Check if the device is mobile based on screen width
  const isMobile = window.innerWidth < 1024;

  // Select all elements to handle
  const infoIcons = document.querySelectorAll(".info-icon");
  const mengeTexts = document.querySelectorAll(".menge-text span");

  // Function to toggle the 'active' class
  const toggleClass = (element, add) => {
    if (add) {
      element.classList.add("active");
    } else {
      element.classList.remove("active");
    }
  };

  if (isMobile) {
    // For mobile devices: handle clicks
    [...infoIcons, ...mengeTexts].forEach((element) => {
      element.addEventListener("click", (e) => {
        e.stopPropagation(); // Prevent event bubbling
        const isActive = element.classList.contains("active");
        // Remove 'active' class from all elements
        [...infoIcons, ...mengeTexts].forEach((el) => el.classList.remove("active"));
        // Add 'active' if it was not active
        if (!isActive) {
          element.classList.add("active");
        }
      });
    });

    // Remove 'active' class when clicking outside the elements
    document.addEventListener("click", () => {
      [...infoIcons, ...mengeTexts].forEach((el) => el.classList.remove("active"));
    });
  } else {
    // For desktop devices: handle hover
    [...infoIcons, ...mengeTexts].forEach((element) => {
      element.addEventListener("mouseenter", () => toggleClass(element, true)); // Add 'active' on hover
      element.addEventListener("mouseleave", () => toggleClass(element, false)); // Remove 'active' on hover out
    });
  }
});